export function buildCategoriesMap(categoriesList, parentId = null) {
    const map = {}

    categoriesList.forEach((category, index) => {
        const sequenceNumber = index + 1

        const categoryId = parentId
            ? `${parentId}.${sequenceNumber}`
            : `${sequenceNumber}`

        const categoryData = {
            title: category.name,
            id: category.id,
            isOpen: false,
            isSelected: false,
        }

        if (category?.children?.length > 0) {
            // Рекурсивный вызов возвращает готовый объект children
            categoryData.children = buildCategoriesMap(
                category.children,
                categoryId
            )
        }

        map[categoryId] = categoryData
    })

    return map
}

function buildModifiers(modifiers) {
    if (!Array.isArray(modifiers)) return []

    return modifiers.map(modifier => ({
        ...modifier,
        count: 1,
    }))
}

export function normalizeModiScheme(modiScheme) {
    if (!modiScheme) return modiScheme

    return {
        ...modiScheme,
        modi_scheme_details: modiScheme.modi_scheme_details?.map(detail => ({
            ...detail,
            modi_group: {
                ...detail.modi_group,
                modifiers: buildModifiers(detail.modi_group?.modifiers),
            },
        })),
    }
}
